import React, { Component } from 'react';

import Core from './../../Core/Core';
import ErrorManager from './../../Core/ErrorManager';



class Apvs extends Component
{
    constructor(props)
    {
        super(props);

        this.edit = this.edit.bind(this);
        this.delete = this.delete.bind(this);
    }

    edit(id)
    {
        window.location.href = "/apv/edit/"+id
    }

    delete(id)
    {
        if(!window.confirm("Etes-vous sûr de vouloir supprimer cet élément ?"))
            return;
        Core.Instance.Request(Core.Address+"APV/"+id, null, "DELETE").then((json)=> {
            ErrorManager.Instance.Info("L'élément a bien été supprimé.");
            window.location.reload();
        });
        
    }

    downloadPDF(name, facture)
    {
        let address = Core.Address+"ApvPdf?name="+name+"&facture="+facture;
        let promise = new Promise((resolve, reject) =>
            {
                let options = {
                    method: "GET",
                    mode: "cors",
                };

                if(address.indexOf(Core.Address) != -1)
                {
                    let token = Core.Instance.user != null ? Core.Instance.user.token : null;
                    if(options.headers == null)
                        options.headers =  { 'X-Authorization': "Token "+token };
                    else 
                        options.headers['X-Authorization'] = "Token "+token;
                }
                var request = fetch(address, options);
                request.then(function(response){
                    return response;
                })
                .then((response) => {
                    let contentType = response.headers.get("content-type");
                    if (contentType && contentType.indexOf("application/json") !== -1) {
                        return response.json().then(function(json) {
                            if(json.error != null && json.error.code == 204)
                            {
                                ErrorManager.Instance.Error("Impossible de récupérer le fichier PDF de la facture.");
                            }
                        });
                    }
                    resolve(response);
                });
            })
            .then((pdf) => {
                return pdf.blob();
            })
            .then((blob) => {
                // Create blob link to download
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', facture+'.pdf');
                //Append to html page
                document.body.appendChild(link);
                //Force download
                link.click();
                // Clean up and remove the link
                link.parentNode.removeChild(link);
            })
            .catch(function(error){
                ErrorManager.Instance.Error("Une erreur est survenue");
            });
    }
    
    render()
    {
        let index = 0;
        let apvs = this.props.apvs == null ? [] : 
        this.props.apvs.map((e) => {
            let date = e.date != null ? (new Date(e.date*1000)) : null;
            if(date != null)
                date = date.getDate().toString().padStart(2, "0")+"/"+(date.getMonth()+1).toString().padStart(2, "0")+"/"+date.getFullYear();
            return (
                <tr key={e.id} >
                    <td><a href="#" onClick={ () => { this.downloadPDF(e.name,e.facture) }}>{ e.facture }</a></td>
                    <td>{ e.name }</td>
                    <td>{ date ? date : '/' }</td>
                    <td>{ e.comments ? e.comments : '/' }</td>
                    <td>{ e.amount}€</td>
                    <td>{ e.code ? e.code : '/' }</td>
                    <td>{ e.km } Km</td>
                    {
                        this.props.editing == true && 
                        <td>
                            <span className='fas fa-edit' onClick={ (ev) => { ev.preventDefault();this.props.loadAPV(e.id) }}/>
                            <span className='far fa-trash-alt ml-2' onClick={ (ev) => { ev.preventDefault();this.delete(e.id) } }/>
                        </td>
                    }
                </tr>
            );
        });
        
        return (
            <div>
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th>N° facture</th>
                            <th>Nom affaire</th>
                            <th>Date facture</th>
                            <th>Commentaires</th>
                            <th>Montant facture</th>
                            <th>Immatriculation</th>
                            <th>Km</th>
                            {
                                this.props.editing ==  true &&
                                <th></th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        { apvs }
                    </tbody>
                </table>
            </div>
        );
    }
}

export default Apvs;


// WEBPACK FOOTER //
// ./src/Components/APV/Apvs.js